import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TActivity from './Tables/TActivity';
import styles from 'src/components/Admin/Result/Results.module.scss';
import { Breadcrumb } from 'antd';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { readVersionIdFromSearch, withVersionQuery } from 'src/geiVersion/display';
const Activities: React.FC = () => {
    interface RouteParams {
        idGei: string;
        idOrganization: string;
    }
    const params = useParams<RouteParams>();
    const history = useHistory();
    const location = useLocation();
    const versionId = readVersionIdFromSearch(location.search);
    return (
        <div>    
             <div>
                <br />
                <div className={styles["admin-header"]}>
                    <div >
                        <span className={styles["header"]} onClick={() => history.push("/gei-inventory")}> Inventario GEI</span>
                        <span> / </span><span className={styles["header"]} onClick={() => history.push(withVersionQuery(`/establishment/gei/${params.idGei}`, versionId))} >Establecimientos</span>
                        <span> / </span><span className={styles["header-bold"]}>Data de actividad</span>
                    </div>
                </div>
                <br />
            </div>
         <TActivity/>
          
     </div>

    );
};
export default Activities;